/**
 * Current task panel: dynamic form + OIN catalog results (extracted from CommandWindow for clarity).
 * Primary OIN search is wired to executeOinSearch() from useIdwiz.
 */
import DynamicForm from "./DynamicForm.jsx";
import OINConfigureForm from "./OINConfigureForm.jsx";
import OINResultsDisplay from "./OINResultsDisplay.jsx";

export default function CurrentTask({
  currentTaskTitle,
  lastAssistantBrief,
  activeFormFields,
  taskFormValues,
  setTaskFormValue,
  formFieldsDisabled = false,
  executeSectionDisabled = false,
  handleFormPrimaryAction,
  formUsesInlinePrimaryExecute,
  formHasOinSearch,
  primaryActionLabelResolved,
  primaryDisabled,
  primaryBusy,
  /** Maps Primary action + Enter to OIN API search (see useIdwiz.executeOinSearch). */
  executeOinSearch,
  oinCatalogUi,
  oinCatalogSearchBusy,
  oinConfigureUi = null,
  oinConfigureSubmitting = false,
  onOinConfigureFieldChange = null,
  onOinConfigureSubmit = null,
  onOinConfigureCancel = null,
  onOinAddToOkta = null,
  oinAddingAppId = null,
  minOinSearchLength = 3,
  dismissSuggestedActionSurface,
  showPrimaryExecute,
  onTaskExecute,
  executionSubmitting,
  phase,
  approveExecuteReady,
  approveDisabledHint,
  executeLabel,
}) {
  return (
    <div className="mr-4 flex min-h-0 flex-1 flex-col rounded-xl border border-[rgb(var(--idaxis-accent-primary-rgb)/0.25)] bg-[rgb(var(--idaxis-accent-primary-rgb)/0.06)] px-4 py-5">
      <p className="text-[10px] font-semibold uppercase tracking-widest text-[rgb(var(--idaxis-accent-primary-rgb)/0.9)]">Current task</p>
      <p className="mt-1 text-base font-semibold text-slate-100">{currentTaskTitle || "In progress"}</p>
      {lastAssistantBrief ? (
        <p className="mt-2 whitespace-pre-wrap text-[13px] leading-relaxed text-slate-300">{lastAssistantBrief}</p>
      ) : null}
      <div className="mt-4 min-h-0 flex-1">
        <DynamicForm
          fields={activeFormFields}
          values={taskFormValues}
          onChange={setTaskFormValue}
          disabled={formFieldsDisabled}
          onSubmit={typeof handleFormPrimaryAction === "function" ? handleFormPrimaryAction : undefined}
          onPrimaryAction={typeof handleFormPrimaryAction === "function" ? handleFormPrimaryAction : undefined}
          primaryActionLabel={primaryActionLabelResolved}
          primaryDisabled={primaryDisabled}
          primaryBusy={primaryBusy}
          executeOinSearch={typeof executeOinSearch === "function" ? executeOinSearch : undefined}
          onOinSearchEnter={typeof executeOinSearch === "function" ? executeOinSearch : undefined}
          oinSearchDisabled={oinCatalogSearchBusy}
          minOinSearchLength={minOinSearchLength}
          onNavigateBack={typeof dismissSuggestedActionSurface === "function" ? dismissSuggestedActionSurface : undefined}
          navigateBackDisabled={oinCatalogSearchBusy}
        />
        {formHasOinSearch ? (
          <OINResultsDisplay
            ui={oinCatalogUi}
            busy={oinCatalogSearchBusy}
            onAddToOkta={typeof onOinAddToOkta === "function" ? onOinAddToOkta : null}
            addingAppId={oinAddingAppId}
          />
        ) : null}
        {formHasOinSearch ? (
          <OINConfigureForm
            ui={oinConfigureUi}
            disabled={formFieldsDisabled || executeSectionDisabled}
            submitting={oinConfigureSubmitting}
            onFieldChange={typeof onOinConfigureFieldChange === "function" ? onOinConfigureFieldChange : undefined}
            onSubmit={typeof onOinConfigureSubmit === "function" ? onOinConfigureSubmit : undefined}
            onCancel={typeof onOinConfigureCancel === "function" ? onOinConfigureCancel : undefined}
          />
        ) : null}
      </div>
      {showPrimaryExecute ? (
        <div className="mt-5 shrink-0 border-t border-[rgb(var(--idaxis-accent-primary-rgb)/0.2)] pt-4">
          <button
            type="button"
            onClick={() => onTaskExecute()}
            disabled={
              executeSectionDisabled || executionSubmitting || phase === "executing" || !approveExecuteReady
            }
            title={!approveExecuteReady ? approveDisabledHint || undefined : undefined}
            className="w-full rounded-lg bg-[rgb(var(--idaxis-accent-primary-rgb)/1)] py-2.5 text-sm font-bold text-[var(--idaxis-bg-primary)] shadow-[0_0_20px_rgb(var(--idaxis-accent-primary-rgb)/0.3)] transition hover:shadow-[0_0_28px_rgb(var(--idaxis-accent-primary-rgb)/0.45)] disabled:cursor-not-allowed disabled:opacity-50"
          >
            {executeLabel}
          </button>
          {approveDisabledHint && !approveExecuteReady ? (
            <p className="mt-2 text-center text-[10px] text-slate-500">{approveDisabledHint}</p>
          ) : null}
        </div>
      ) : null}
    </div>
  );
}
